/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerRemoveMutationResponse, TemplatesControllerRemovePathParams, TemplatesControllerRemoveQueryParams, TemplatesControllerRemove401, TemplatesControllerRemove403, TemplatesControllerRemove404 } from "../../models/checklistsController/TemplatesControllerRemove";

function getTemplatesControllerRemoveUrl(id: TemplatesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-templates/${id}` as const }  
  return res
}

/**
 * @summary Delete a checklist template (soft delete with optional recursive parent deletion)
 * {@link /api/v1/checklist-templates/:id}
 */
export async function templatesControllerRemove(id: TemplatesControllerRemovePathParams["id"], params?: TemplatesControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplatesControllerRemoveMutationResponse, ResponseErrorConfig<TemplatesControllerRemove401 | TemplatesControllerRemove403 | TemplatesControllerRemove404>, unknown>({ method : "DELETE", url : getTemplatesControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}